/*!
 * Geckio — © Panthure ApS (CVR 45983331). All rights reserved.
 * 
 * This theme is licensed, not sold. A licence covers ONE live Shopify store and is valid
 * only when the theme was purchased from geckio.io. It may not be resold, redistributed,
 * sub-licensed, or used to build stores for third parties without a licence per store.
 * 
 * Modifying it for the store it is licensed to is expressly allowed and encouraged.
 * 
 * geckio.io · support@geckio.io
 */
/* ============================================================
   <geckio-slider> — THE shared carousel (spec §5.11).
   CSS scroll-snap does the scrolling (native touch, zero CLS);
   this only adds arrows, dots, keyboard support and state.
   Replaces every bespoke slider implementation in the theme.

   Markup contract:
     <geckio-slider class="geckio-slider">
       <ul class="geckio-slider__track" data-slider-track role="list">
         <li class="geckio-slider__slide">…</li>
       </ul>
       {% render 'slider-controls', label: '…' %}
     </geckio-slider>
   ============================================================ */
(function () {
  if (!window.customElements || window.customElements.get('geckio-slider')) return;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  class GeckioSlider extends HTMLElement {
    connectedCallback() {
      if (this.__ready) return;
      this.__ready = true;

      this.track = this.querySelector('[data-slider-track]');
      if (!this.track) return;

      this.slides = Array.prototype.slice.call(this.track.children);
      this.prevBtn = this.querySelector('[data-slider-prev]');
      this.nextBtn = this.querySelector('[data-slider-next]');
      this.dotsWrap = this.querySelector('[data-slider-dots]');

      // Scrollable regions must be keyboard reachable.
      this.track.setAttribute('tabindex', '0');

      // A single slide is not a carousel — hide the controls rather than show dead arrows.
      if (this.slides.length < 2) this.classList.add('is-static');

      this.buildDots();
      this.bind();
      this.update();
    }

    step() {
      if (this.slides.length < 2) return Math.max(1, this.track.clientWidth);
      var a = this.slides[0].getBoundingClientRect();
      var b = this.slides[1].getBoundingClientRect();
      return Math.max(1, b.left - a.left);
    }

    index() {
      return Math.round(this.track.scrollLeft / this.step());
    }

    goTo(i) {
      i = Math.max(0, Math.min(this.slides.length - 1, i));
      this.track.scrollTo({ left: i * this.step(), behavior: reduce ? 'auto' : 'smooth' });
    }

    buildDots() {
      if (!this.dotsWrap) return;
      var self = this;
      this.dotsWrap.innerHTML = '';
      this.slides.forEach(function (slide, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'geckio-slider__dot';
        b.setAttribute('role', 'tab');
        b.setAttribute('aria-label', ((window.geckioStrings||{}).goToSlide || 'Gå til %% af %#').replace('%%', i + 1).replace('%#', self.slides.length));
        b.addEventListener('click', function () { self.goTo(i); });
        self.dotsWrap.appendChild(b);
      });
    }

    bind() {
      var self = this;
      var raf;

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.goTo(self.index() - 1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.goTo(self.index() + 1); });

      this.track.addEventListener('scroll', function () {
        if (raf) window.cancelAnimationFrame(raf);
        raf = window.requestAnimationFrame(function () { self.update(); });
      }, { passive: true });

      this.track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); self.goTo(self.index() + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.goTo(self.index() - 1); }
      });

      window.addEventListener('resize', function () { self.update(); }, { passive: true });
    }

    update() {
      var i = this.index();
      var atStart = this.track.scrollLeft <= 2;
      var atEnd = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;

      if (this.prevBtn) this.prevBtn.disabled = atStart;
      if (this.nextBtn) this.nextBtn.disabled = atEnd;

      if (this.dotsWrap) {
        var dots = this.dotsWrap.children;
        for (var d = 0; d < dots.length; d++) {
          var on = d === i;
          dots[d].classList.toggle('is-active', on);
          dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
        }
      }
    }
  }

  window.customElements.define('geckio-slider', GeckioSlider);
})();
